module.exports = __webpack_public_path__ + "img/ANJ.42cb5e1b.png";